<template>
    <div>
        <el-card v-show="fix_pic_list && fix_pic_list.length>0" style="margin-bottom: 10px;">
          <el-row :gutter="20">
            <el-col :span="10">
              <img :src="item" v-for="item in fix_pic_list" />
            </el-col>
          </el-row>
        </el-card>
        <el-card>
            <el-row :gutter="20">
                <el-col :span="10">
                    <el-button  type="primary"  @click="downloadDetail()">
                        下载打款细则
                    </el-button>
                </el-col>
                <h3>{{wenan}}</h3>
            </el-row>
            <!-- 表格数据 -->
            <el-table :data="goodsList" border stripe v-loading="loading" >
                <el-table-column type="index"></el-table-column>
                <el-table-column label="交易号" prop="out_biz_no" ></el-table-column>
                <el-table-column label="状态" prop="status_wenan"></el-table-column>
                <el-table-column label="描述" prop="wenan" ></el-table-column>
                <el-table-column label="收款人" prop="payee_info.name" ></el-table-column>
                <el-table-column label="收款账号" prop="payee_info.account" ></el-table-column>
                <el-table-column label="备注" prop="remark" width="220px"></el-table-column>
                <el-table-column label="创建时间" prop="gmt_create">
                    <template slot-scope="scope">{{scope.row.gmt_create }}</template>
                </el-table-column>
                <el-table-column label="结束时间" prop="gmt_finish">
                    <template slot-scope="scope">{{scope.row.gmt_finish }}</template>
                </el-table-column>
            </el-table>
            <!-- 分页区域 -->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[100, 200, 500]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
            ></el-pagination>
        </el-card>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                queryInfo: {
                    query: '',
                    pagenum: 1,
                    pagesize: 100
                },
                fix_pic_list:[],
                // 商品列表
                goodsList: [],
                // 商品总数
                total: 0,
                offset:0,
                id:"",
                loading:true,
                demo:"",
                ologid:"",
                wenan:""
            }
        },
        created(){
            this.id = this.$route.params.id
            var test = window.location.href.split("?");
            if(test[1]){
                var str=test[1].split("=");
                this.ologid = str[1]
            }
            this.getList();
        },
        methods:{
            async getList(){
                let that=this;
                var ask =  {
                        "oper": "get_pm_detail_list",
                        "ent": "order_log_id",
                        "info": {
                            "id":this.id,
                            "count":this.queryInfo.pagesize,
                            "offset":this.offset,
                        }
                    };
                if(this.ologid.length>0){
                    ask.info["ologid"]=this.ologid
                }
                const { data: res } = await this.$http.post('',ask )
                console.log(res)
                if(res.code==0){
                    this.wenan = res.data.wenan;
                    this.goodsList = res.data.data_list;
                    this.fix_pic_list=res.data.fix_pic_list;
                    that.total = res.data.total_count;
                    this.loading=false;
                    this.offset+=this.queryInfo.pagesize;
                }else{
                    this.$message(res.msg);
                }

            },

            async download(){
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "get_pmd_list_url",
                        "ent": "order_log_id",
                        "info": {
                            "id":this.id
                        }
                    }
                )
                if(res.code==0){
                    this.demo=res.data.url;
                }else{
                    this.$message(res.msg);
                }
                console.log(res)
                // window.location.href = res.data.url;
            },
            handleCurrentChange (newSize) {
                this.queryInfo.pagenum = newSize
                this.offset=(newSize-1)*this.queryInfo.pagesize
                this.getList()
            },
            handleSizeChange (newSize) {
                this.queryInfo.pagesize = newSize
                this.offset=0
                this.getList()
            },
            downloadDetail(){
                let that=this;
                Promise.resolve(this.download()).then(function () {
                    if(that.demo.length>0) {
                        const aTag = document.createElement('a')
                        aTag.href = that.demo;
                        aTag.click()
                    }
                });
            }


        }
    }
</script>

<style scoped>
    .download{
        width: 100px;
        height: 30px;
        background: #909399;
        color:white
    }
</style>
